import React, { useRef, useState } from "react";

import { Button } from "reactstrap";
import cx from "classnames";

import { trimKey } from "../../../../helpers/Utils";
import Icon from "../../../../components/Icon/Icon";
import ArrowLeftIcon from "../../../../components/Icon/icons/account/ArrowLeftIcon";
import ArrowDoubleIcon from "../../../../components/Icon/icons/account/ArrowDoubleIcon";

import s from "./WalletAvatarWidget.module.scss";

export default function WalletAvatarWidget(props) {
	const { user, isConnected, showSwitcher } = props;
	const [showLogout, setShowLogout] = useState(false);
	const [, setShowCopyTooltip] = useState(false);
	const [isCopied, setIsCopied] = useState(false);

	const { name, publicKey, metamaskAccount } = user;
	const tooltipCopyRef = useRef(null);

	// ------------------------------------- METHODS -------------------------------------
	const copyToClipboard = async () => {
		setIsCopied(true);

		setShowCopyTooltip(false);
		setTimeout(() => {
			setShowCopyTooltip(true);
		}, 10);

		if ("clipboard" in navigator) {
			return navigator.clipboard.writeText(publicKey);
		}
	};

	const switchWallet = () => {
		props.logout();
	};

	const logout = () => {
		setShowLogout(false);
		props.logout();
	};

	return (
		<div className={s.root}>
			<div className={s.mediaContainer}>
				{isConnected && showSwitcher ? (
					<Button
						className={cx(s.button, "btn-default dark")}
						color="primary"
						onClick={switchWallet}
					>
						<Icon icon="fox" />
						<span>Switch Wallet</span>
						<div className={s.iconContainer}>
							<ArrowDoubleIcon color="#000" bgColor="transparent" />
						</div>
					</Button>
				) : null}

				<div
					className={s.avatarContainer}
					onMouseEnter={() => setShowLogout(true)}
					onMouseLeave={() => setShowLogout(false)}
				>
					<div
						className={s.accountInfo}
						ref={tooltipCopyRef}
						onClick={copyToClipboard}
					>
						<p className={s.account}>
							{name || trimKey(metamaskAccount, true) || "no name"}
						</p>
						{publicKey && (
							<div className={s.keyContainer}>
								<span className={cx(s.key, { [s.keyCopied]: isCopied })}>
									{trimKey(publicKey)}
								</span>
								<Icon
									icon={isCopied ? "copyDone" : "copy"}
									className={s.icon}
								/>
							</div>
						)}
					</div>

					<Icon icon={user.avatar || "walletAvatar"} className={s.avatar} />

					{showLogout && isConnected ? (
						<div className={s.logoutButton} onClick={logout}>
							<ArrowLeftIcon />
							<p className={s.logoutText}>Logout</p>
						</div>
					) : null}
				</div>
			</div>

			{/* {showCopyTooltip ? (
				<Tooltip placement="bottom" target={tooltipCopyRef} isOpen={true}>
					<p className="tooltip-text">
						{isCopied ? "Copied" : "Copy to clipboard"}
					</p>
				</Tooltip>
			) : null} */}
		</div>
	);
}
